import { render, staticRenderFns } from "./FoodSet.vue?vue&type=template&id=15e065f8&scoped=true&"
import script from "./FoodSet.vue?vue&type=script&lang=tsx&"
export * from "./FoodSet.vue?vue&type=script&lang=tsx&"
import style0 from "./FoodSet.vue?vue&type=style&index=0&id=15e065f8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e065f8",
  null
  
)

export default component.exports